import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../utils/innerpage.css'
import { search_calender_action, block_calender_action } from '../../actions/calender_actions/calender_action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import { cityActionId, centerActionId, ClientActionId, timeSlotActionId, toastError, toastSuccess } from '../../utils/constants'
import { fill_action } from '../../actions/fillList_action';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../utils/Loader'
import { clearSessionStorage } from '../../utils/constants'
import Pagination from '../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { data } from 'jquery';
import Dropdown from 'react-dropdown'
import Header from '../../common_components/Header';

class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
    }

    componentDidMount() {
        var accessArr = []
        console.log(JSON.parse(sessionStorage.getItem('UserLoginData')))
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) != null) {
            if (JSON.parse(sessionStorage.getItem('UserLoginData')).loginAccesslist.length != 0) {
                for (var i = 0; i < JSON.parse(sessionStorage.getItem('UserLoginData')).loginAccesslist.length; i++) {
                    if (JSON.parse(sessionStorage.getItem('UserLoginData')).loginAccesslist[i].ReadAccess == true) {
                        accessArr.push(JSON.parse(sessionStorage.getItem('UserLoginData')).loginAccesslist[i].ModuleID)
                    }
                }
                console.log(accessArr)
                if (!accessArr.includes(1)) {
                    setTimeout(() => {
                        this.props.navigate('/login')
                    }, 500);
                }
            }
            else {
                setTimeout(() => {
                    this.props.navigate('/login')
                }, 500);
            }
        }
        else {
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }
    }

    render() {
        const { isLoading } = this.state

        return (

            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">

                    <Header data={[1]} />
                </main>
            </>)
    }
}

export default withRouter(connect(null, {})(Dashboard));